import React, { Component, Fragment } from "react";
import styled from "styled-components";
import { Typography } from "@material-ui/core";

import { Bar } from "react-chartjs-2";
const BorderPaper = styled.div`
    margin-top: 10px;
    padding: 20px;
`;
export default class BarChart extends Component {
    render() {
        const { chartData, title } = this.props;

        return (
            <Fragment>
                <BorderPaper>
                    <Typography variant="body2">
                        <b>{title}</b>
                    </Typography>
                    {chartData && (
                        <div>
                            <Bar
                                height={300}
                                options={{
                                    maintainAspectRatio: false,
                                    responsive:true,
                                    scales: {
                                        yAxes: [
                                            {
                                                ticks: {
                                                    beginAtZero: true
                                                }
                                            }
                                        ]
                                    }
                                }}
                                data={chartData}
                            />
                        </div>
                    )}
                </BorderPaper>
            </Fragment>
        );
    }
}
